import Vue from 'vue'
import Router from 'vue-router'
import displayAll from '@/pages/display-all.vue'
import set from '@/pages/set.vue'
import medicineShow from '@/pages/medicineShow.vue'
import doctorSet from '@/pages/doctorSet.vue'
import doctorDisplayAll from '@/pages/doctorDisplay-all.vue'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'doctorSet',
      component: doctorSet
    },
    {
      path: '/doctorDisplay-all',
      name: 'doctorDisplayAll',
      component: doctorDisplayAll
    },
    {
      path: '/medicineShow',
      name: 'medicineShow',
      component: medicineShow
    },
    {
      path: '/set',
      name: 'set',
      component: set
    },
    {
      path: '/BigScreen',
      name: 'index',
      component: displayAll
    }
  ]
})
router.beforeEach((to, from, next) => {
  // let params = window.localStorage.getItem('params')
  // console.log(params)
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js